import React from "react";
import { NotificationContainer } from "react-notifications";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router";
import { createBrowserRouter } from "react-router-dom";

import { removeItemSession, saveItemSession } from "utils/session";
import { RefreshKey } from "constants/constantStrings";
import ROUTES_PATH from "constants/pages.constant";

import SSOProvider from "./components/SSOProvider";
import APP_ROUTES from "./AppRoutes";
import configureStore from "./store";

export const store = configureStore();

const REACT_APP_CALL_BACK_URL = window.location.hostname === "localhost" ? process.env.REACT_APP_BASE_URL_LOCAL : window.location.origin;

window.onbeforeunload = () => {
  const lastVisitedURL = window.location.pathname + window.location.search;
  saveItemSession(RefreshKey.lastVisitedURL, lastVisitedURL);
  if (lastVisitedURL.includes(ROUTES_PATH.SETTINGS)) {
    saveItemSession(RefreshKey.pageRefreshed, true);
  } else {
    removeItemSession(RefreshKey.pageRefreshed);
  }
};

const router = createBrowserRouter(APP_ROUTES);

class App extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <SSOProvider
          loginUrl={process.env.REACT_APP_LOGIN_URL}
          clientId={process.env.REACT_APP_CONSUMER_KEY}
          clientSecret={process.env.REACT_APP_COMSUMER_SECRET}
          redirectUri={REACT_APP_CALL_BACK_URL}
        >
          <RouterProvider router={router} />
        </SSOProvider>
        <NotificationContainer />
      </Provider>
    );
  }
}

export default App;
